// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"dfdb0d71","455":"cf487823","495":"4845acbf","578":"83fb9dc2","977":"bab33472"}[chunkId] + ".chunk.js";
};